<template>
    <div class="table-pagination">
        <div class="pagination-select">
            <span class="pagination-item-label">Show</span>
            <CCSelect :options="paginationOptions"
                      :selected="limit"
                      :onChangeEvent="onChangePaginationLimit" style="padding: 5px 20px 5px 10px;background-size: 1.35em; line-height: 19px;"></CCSelect>
        </div>
        <div class="pagination-wrapper">
        <span class="previous-page-wrapper"
              v-if="((totalCount > limit) && this.$store.getters[this.namespace + '/hasPreviousPage'])" @click="previousPage()">
          <i class="previous-page"></i>
        </span>
            <span class="current-page-wrapper">
          <template v-if="numberRows < totalCount && numberRows !== null">
            {{numberRows}}
          </template>
          <template v-else-if="numberRows === null">
            {{numberRows}}
          </template>
          <template v-else>
            {{totalCount}}
          </template>
        </span>
            <span class="numRows">of {{totalCount}}</span>
            <span class="next-page-wrapper" v-if="(numberRows < totalCount) && this.$store.getters[this.namespace + '/hasNextPage']"
                  @click="nextPage()">
          <i class="next-page"></i>
        </span>
        </div>
    </div>
</template>

<script>

    import CCSelect from '@/components/common/CCSelect';

    export default {
        name: "cc-table-pagination",
        props: {
            numberRows: {
                type: Number,
                required: true
            },
            paginationOptions: {
                type: Array,
                required: true
            },
            limit: {
                type: Number,
                required: true
            },
            totalCount: {
                type: Number,
                required: false
            }
        },
        components: {
            CCSelect
        },
        data() {
            return {
                namespace: 'adgroupReport',
            }
        },
        methods: {
            onChangePaginationLimit: function(newValue){
                this.$emit('changePagination', newValue);
            },
            previousPage(){
                this.$emit('previousPage');
            },
            nextPage(){
               this.$emit('nextPage');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .table-pagination {
        display: flex;
        justify-self: right;
        margin-top: 20px;

        & > .pagination-select {
            display: flex;
            justify-content: flex-end;
            margin-right: 10px;

            .pagination-item-label {
                margin: auto 10px auto 0;
            }
        }
    }

    .pagination-wrapper {
        display: flex;
        margin-right: 20px;
        align-items: baseline;

        & .numRows {
            margin-left: 5px;
            margin-right: 5px;
        }
    }

    .pagination-item-select {

    }

    .current-page-wrapper {
        padding: 7px 14px;
        border: 1px solid $border-color;
        border-radius: $border-radius;
    }

    .previous-page-wrapper {

        padding: 7px 14px;
        border: 1px solid $border-color;
        border-radius: $border-radius;
        cursor: pointer;

        .previous-page {
            display: inline-block;
            width: 0.65em;
            height: 0.65em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/navigation-previous-page-icon.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
    }

    .next-page-wrapper {

        padding: 7px 14px;
        border: 1px solid $border-color;
        border-radius: $border-radius;
        cursor: pointer;

        .next-page {
            display: inline-block;
            width: 0.65em;
            height: 0.65em;
            margin-right: 5px;
            margin-left: 5px;
            background-image: url('/static/img/navigation-next-page-icon.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
        }
    }

    @include mobile-only {
        .previous-page-wrapper {
            margin-right: 5px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/common/table/CCTablePagination.vue